import { useQuery } from 'react-query'
import axios from 'axios'

const useGetConfig = () => {
  const fetchConfig = async () => {
    const resp = await axios.get('api/config/readTourneyConfig.php')
    return resp.data
  }

  return useQuery('tourneyConfig', fetchConfig, { staleTime: 5 * 60 * 1000 })
}

export default useGetConfig
